import { gql } from '@apollo/client';

export const GET_DELIVERY_TASK_REVIEWS_WITH_COUNT = gql`
  query GetDeliveryTaskReviewsWithCount($filter: DeliveryTaskReviewFilterInput!) {
    getDeliveryTaskReviewsWithCount(filter: $filter) {
          id
          dspId
          dspName
          dspPhone
          accountId
          accountIdList
          dspLevelReviewIdList
          warehouseId
          warehouseName
          taskDate
          submitType
          unScannedCount
          scanOtherDriverParcelCount
          scanOtherDriverParcelDisplayCount
          otherDriverScanCurrentDriverParcelCount
          createdAt
          updatedAt
    }
  }
`;

export interface DeliveryTaskReviewWithCountTypeResponse {
    getDeliveryTaskReviewsWithCount: DeliveryTaskReviewWithCountType[];
}

export interface DeliveryTaskReviewWithCountType {
    id: string;
    dspId: string;
    dspName: string;
    dspPhone:string;
    accountId: string;
    accountIdList: number[] | null;
    dspLevelReviewIdList: number[] | null;
    warehouseId: string;
    warehouseName: string;
    taskDate: string;
    submitType: number;
    unScannedCount: number;
    scanOtherDriverParcelCount: number;
    scanOtherDriverParcelDisplayCount: number;
    otherDriverScanCurrentDriverParcelCount: number;
    createdAt: string;
    updatedAt: string;
}

